export default "__VITE_ASSET__Cl_i5Vjb__"